import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import {
  getCardHolder,
  saveCardHolder,
  createCardholder,
  deleteCardholder,
  sendInvitaion,
  updateCardholder,
  checkStatus,
  getAllCardholders,
} from '~/api/cardholder';

export const useGetCardHolder = () => {
  return useQuery([], getCardHolder, {});
};

export const useGetCardHolderError = (location?: string) => {
  return useQuery([], getCardHolder, { enabled: location === '/cardHolder/details' });
};

export const useSaveCardHolderDetails = () => {
  const history = useHistory();
  return useMutation(saveCardHolder, {
    onMutate() {
      console.log('Mutation');
    },
    onSuccess(res) {
      console.log('onSuccess..', res);
      // history.push(paths.cardHolder.completion);
    },
    onSettled() {
      console.log('onSettled');
    },
  });
};

export const useCreateCardholder = () => {
  return useMutation(createCardholder);
};

export const useUpdateCardholder = () => {
  return useMutation(updateCardholder);
};

export const useDeleteCardholder = () => {
  return useMutation(deleteCardholder);
};

export const useSendInvitaion = () => {
  return useMutation(sendInvitaion);
};
export const useCheckStatus = () => {
  return useQuery('agentAssignee', checkStatus, { staleTime: Infinity });
};

export const useGetCardholders = () => {
  return useQuery('allCardholdersInfo', getAllCardholders, { staleTime: 0, cacheTime: 0 });
};
